// extracted by mini-css-extract-plugin
export default {"mn-card-leave-comment-windows":"index_mn-card-leave-comment-windows__tMsDZ"};